export interface SubscriptionData {
  tier: string;
  isActive: boolean;
  startDate: string;
  endDate?: string;
  dailyLimit: number;
  isExpired: boolean;
}

class SubscriptionService {
  private readonly apiUrl: string;

  constructor() {
    this.apiUrl = import.meta.env.VITE_API_URL;
  }

  async getSubscription(accessToken: string): Promise<SubscriptionData> {
    const response = await fetch(`${this.apiUrl}/api/subscription`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch subscription');
    }

    return await response.json();
  }

  async createSubscription(
    accessToken: string,
    priceId: string
  ): Promise<{ clientSecret: string; subscriptionId: string }> {
    const response = await fetch(`${this.apiUrl}/api/subscription/create`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ priceId })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create subscription');
    }

    return await response.json();
  }

  async createPortalSession(
    accessToken: string,
    returnUrl: string
  ): Promise<{ url: string }> {
    const response = await fetch(`${this.apiUrl}/api/subscription/portal`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ returnUrl })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create portal session');
    }

    return await response.json();
  }
}

export const subscriptionService = new SubscriptionService();